import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState, useEffect, useMemo } from 'react';
import { ChevronUp } from '../../icons';
import { getTestIds } from '../../utils/TestIds';
import { IconButton } from '../IconButton';
import styles from './ScrollToTopButton.module.scss';
export const GetScrollToTopButtonTID = (parentTestId)=>getTestIds(parentTestId);
export const ScrollToTopButton = (props)=>{
    const { scrollContainer, scrollBehavior = 'smooth', testId, bi } = props, rest = _object_without_properties(props, [
        "scrollContainer",
        "scrollBehavior",
        "testId",
        "bi"
    ]);
    const { ScrollToTopButtonTID } = useMemo(()=>GetScrollToTopButtonTID(testId), [
        testId
    ]);
    const [showTopBtn, setShowTopBtn] = useState(false);
    const [hasListener, setHasListener] = useState(false);
    const scrollToTop = ()=>{
        if (scrollContainer) {
            scrollContainer.scroll({
                top: 0,
                behavior: scrollBehavior
            });
        }
    };
    useEffect(()=>{
        if (scrollContainer) {
            const onScroll = ()=>{
                setShowTopBtn(scrollContainer.scrollTop >= 10);
            };
            scrollContainer.addEventListener('scroll', onScroll);
            setHasListener(true);
            return ()=>{
                scrollContainer.removeEventListener('scroll', onScroll);
            };
        }
    }, [
        scrollContainer
    ]);
    return /*#__PURE__*/ _jsx("div", {
        "data-listening": hasListener,
        "data-testid": ScrollToTopButtonTID.Listener(),
        children: showTopBtn && /*#__PURE__*/ _jsx(IconButton, _object_spread_props(_object_spread({
            className: styles.goUpBtn,
            testId: ScrollToTopButtonTID.Root(),
            onClick: ()=>scrollToTop(),
            bi: bi
        }, rest), {
            children: /*#__PURE__*/ _jsx(ChevronUp, {})
        }))
    });
};
